// extracted by mini-css-extract-plugin
export const container = "menuBrowse-module--container--1mKmz";
export const head = "menuBrowse-module--head--1tRM3";
export const courseName = "menuBrowse-module--courseName--mrZL0";
export const menuName = "menuBrowse-module--menuName--3rak-";
export const productName = "menuBrowse-module--productName--3weMz";